import React, { useEffect, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectFade, Navigation, Pagination, Autoplay, EffectFlip } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import './HomePages/home.css';
import 'swiper/css/effect-flip';
import { handleDecrypt } from '@/functions';
import globalIP from '@/GlobelIP';
import { Button, Col, Divider, Grid, Loader, Notification, Row, Stack } from 'rsuite';
import { useNavigate } from 'react-router-dom';
import useLabel from './hook/Label';
import axios from 'axios';
import { useSelectedProducts } from '@/store/QuerySelectred';
import ugr from '@/UGRoute';
export default function SlideShowPage() {
  const [matchingProductIds, setMatchingProductIds] = useState([]);
  const [cata, setCata] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [selectedImagePath, setSelectedImagePath] = useState({ url: '', id: '', default: true });
  const [increaseNum, setIncreaseNum] = useState(5);
  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(25);
  const [fetchedProducts, setFetchedProducts] = useState([]);
  const catalogueCode = handleDecrypt(sessionStorage.getItem('E-typecode'));
  const { attributesName } = useLabel();
  const { selectedItems, handleCheckChange, isSelectedLoading } = useSelectedProducts();
  const cltCode = handleDecrypt(sessionStorage.getItem('E-cli'));
  const C_A_id = handleDecrypt(sessionStorage.getItem('E-C_A_id'));
  const navigate = useNavigate();
  const [allProductData, setAllProductData] = useState([]);
  const [isShowButtons, setIsShowButtons] = useState({
    ppt: false,
    filter: false,
    slideShow: true,
    SmartSearch: false,
    visualProduct: false
  });
  const [isLoadingPage, setIsLoadingPage] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      const {
        data: {
          data: { attributes }
        }
      } = await axios.get(
        `${globalIP}/api/client-logins/${sessionStorage.getItem('user_id')}?populate=*`
      );
      setIsShowButtons(prev => ({
        ppt: attributes.downloadppt,
        filter: attributes.showfilter,
        slideShow: attributes.SlideShow == null || attributes.SlideShow == false ? false : true,
        SmartSearch:
          attributes.SmartSearch == null || attributes.SmartSearch == false ? false : true,
        visualProduct:
          attributes.visualProduct == null || attributes.visualProduct == false ? false : true
      }));
    };
    fetchData();
  }, []);
  if (!isShowButtons.slideShow) {
    navigate(`/${ugr}/client/home-page`);
  }
  const [attributesData, setAttributesData] = useState({});

  useEffect(() => {
    const fetchDatacata = async () => {
      if (catalogueCode) {
        const response = await fetch(
          `${globalIP}/api/catalogues?populate=*&filters[CatalogueCode][$eq]=${catalogueCode}`
        );
        const json = await response.json();
        setCata(json.data);
      }
    };
    fetchDatacata();
  }, [catalogueCode]);
  useEffect(() => {
    const allCatalogProducts = cata.flatMap(item =>
      item.attributes.CatalogueProduct.map(product => product.CatalogProduct)
    );
    setMatchingProductIds(allCatalogProducts);
  }, [cata]);
  useEffect(() => {
    if (cata.length) {
      setAttributesData({
        Cust_Aliascode: cata[0].attributes.Cust_Aliascode,
        Cust_CBM: cata[0].attributes.Cust_CBM,
        Cust_Category: cata[0].attributes.Cust_Category,
        Cust_Color: cata[0].attributes.Cust_Color,
        Cust_Description: cata[0].attributes.Cust_Description,
        Cust_Finish: cata[0].attributes.Cust_Finish,
        Cust_FreeSize: cata[0].attributes.Cust_FreeSize,
        Cust_GrsWgt: cata[0].attributes.Cust_GrsWgt,
        Cust_NetWgt: cata[0].attributes.Cust_NetWgt,
        Cust_Productname: cata[0].attributes.Cust_Productname,
        Cust_Producttype: cata[0].attributes.Cust_Producttype,
        Cust_SalePrice: cata[0].attributes.Cust_SalePrice,
        Cust_Unit: cata[0].attributes.Cust_Unit
      });
    }
  }, [cata[0]]);
  // useEffect(() => {
  //   const fetchProducts = async matchingIds => {
  //     try {
  //       setIsLoadingPage(true);
  //       const productIdsQueryParam = matchingIds
  //         .map(id => `filters[ProductId][$in][]=${id}`)
  //         .join('&');
  //       const apiUrl = `${globalIP}/api/products?${productIdsQueryParam}&populate=*`;
  //       const response = await fetch(apiUrl);
  //       const json = await response.json();
  //       setFetchedProducts(prev => [...prev, ...json.data]);
  //       setStartIndex(25);
  //       setEndIndex(50);
  //       setIsLoadingPage(false);
  //     } catch (error) {
  //       console.error('Error fetching products:', error);
  //     }
  //   };

  //   if (matchingProductIds.length > 0) {
  //     const slicedData = matchingProductIds.slice(0, 25);
  //     fetchProducts(slicedData);
  //   } else {
  //     setFetchedProducts([]);
  //   }
  // }, [matchingProductIds]);

  // useEffect(() => {
  //   if (matchingProductIds.length > fetchedProducts.length) {
  //     const calc = fetchedProducts.length / increaseNum;
  //     if (fetchedProducts.length - calc == activeIndex && fetchedProducts.length) {
  //       const fetchData = async () => {
  //         try {
  //           const slicedIds = matchingProductIds.slice(startIndex, endIndex);
  //           if (slicedIds.length) {
  //             const productIdsQueryParam = slicedIds
  //               .map(id => `filters[ProductId][$in][]=${id}`)
  //               .join('&');
  //             const apiUrl = `${globalIP}/api/products?${productIdsQueryParam}&populate=*`;
  //             const response = await fetch(apiUrl);
  //             const json = await response.json();
  //             setFetchedProducts(prev => [...prev, ...json.data]);
  //             setStartIndex(prevIndex => prevIndex + 25);
  //             setEndIndex(prevIndex => prevIndex + 25);
  //             setIncreaseNum(prev => prev + 5);
  //           }
  //         } catch (error) {
  //           console.error('Error fetching next batch of products:', error);
  //         }
  //       };
  //       fetchData();
  //     }
  //   }
  // }, [activeIndex]);
  useEffect(() => {
    const fetchAllData = async () => {
      setIsLoadingPage(true);
      if (matchingProductIds.length) {
        const pageSize = 25;
        const totalPages = Math.ceil(matchingProductIds.length / pageSize);
        const allData = [];

        for (let page = 1; page <= totalPages; page++) {
          const startIndex = (page - 1) * pageSize;
          const endIndex = Math.min(startIndex + pageSize, matchingProductIds.length);
          const pageIds = matchingProductIds.slice(startIndex, endIndex);
          const ids = pageIds.map(id => `filters[id][$in][]=${id}`).join('&');
          const { data } = await axios.get(`${globalIP}/api/products?${ids}&populate=*`);
          allData.push(...data.data);
        }
        setAllProductData(allData);
        setIsLoadingPage(false);
      }
    };

    fetchAllData();
  }, [matchingProductIds]);

  const capitalizeFirstLetter = string => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };
  const [allQyeryData, setAllQyeryData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      const email = sessionStorage.getItem('loginemail');
      const mobile = sessionStorage.getItem('loginmobile');
      const userName = sessionStorage.getItem('loginusername');
      if (email && mobile) {
        const response = await fetch(
          `${globalIP}/api/clientactivities?populate=*&filters[loginemail][$eq]=${email}&filters[loginmobile][$eq]=${mobile}&filters[loginusername][$null]=true`
        );
        const allSelectedItems = await response.json();
        setAllQyeryData(allSelectedItems.data.flatMap(item => item.attributes.sentquery));
      } else if (email && userName) {
        const response = await fetch(
          `${globalIP}/api/clientactivities?populate=*&filters[loginemail][$eq]=${email}&filters[loginusername][$eq]=${userName}&filters[loginmobile][$null]=true`
        );
        const allSelectedItems = await response.json();
        setAllQyeryData(allSelectedItems.data.flatMap(item => item.attributes.sentquery));
      } else if (userName) {
        const response = await fetch(
          `${globalIP}/api/clientactivities?populate=*&filters[loginemail][$null]=true&filters[loginmobile][$null]=true&filters[loginusername][$eq]=${userName}`
        );
        const allSelectedItems = await response.json();
        setAllQyeryData(allSelectedItems.data.flatMap(item => item.attributes.sentquery));
      }
    };

    fetchData();
  }, []);
  if (isLoadingPage) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: '80vh'
        }}
        color="cyan"
      >
        <Loader size="lg" />
      </div>
    );
  }
  return (
    <div style={{ margin: '10px 0 50px 0' }}>
      <Swiper
        navigation={true}
        effect={'flip'}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        }}
        grabCursor={true}
        // pagination={{
        //   clickable: true
        // }}
        modules={[EffectFade, Navigation, EffectFlip, Autoplay]}
        onSlideChange={item => setActiveIndex(item.activeIndex)}
        className="mySwiper mobile-hide-slide"
        style={{ zIndex: 1000000 }}
      >
        {allProductData.map(item => {
          const exist = allQyeryData?.some(it => it?.productid == item?.id);
          return (
            <SwiperSlide key={item.id}>
              <Grid fluid>
                <Row>
                  <Col lg={12}>
                    <div className="slide-main-image">
                      <img
                        src={
                          selectedImagePath.url && selectedImagePath.id == item.id
                            ? `${globalIP}${selectedImagePath.url}`
                            : `${globalIP}${item?.attributes?.CoverImage?.data?.attributes?.url}`
                        }
                        className="iiimge"
                        alt=""
                      />
                      <div className="selected-button" style={{ zIndex: 100 }}>
                        <span className="heart-circle">
                          {!exist ? (
                            <div
                              onClick={() =>
                                handleCheckChange(
                                  item.id,
                                  !selectedItems.includes(item.id),
                                  item.attributes.ProductCode
                                )
                              }
                              style={{ display: 'flex' }}
                            >
                              {selectedItems.includes(item.id) ? (
                                <svg className="heart" viewBox="0 0 32 29.6">
                                  <path
                                    d="M23.6,0c-3.4,0-6.3,2.7-7.6,5.6C14.7,2.7,11.8,0,8.4,0C3.8,0,0,3.8,0,8.4c0,9.4,9.5,11.9,16,21.2
	c6.1-9.3,16-12.1,16-21.2C32,3.8,28.2,0,23.6,0z"
                                  />
                                </svg>
                              ) : (
                                <span className="material-symbols-outlined">favorite</span>
                              )}
                            </div>
                          ) : (
                            <svg className="heart-1" viewBox="0 0 32 29.6">
                              <path
                                d="M23.6,0c-3.4,0-6.3,2.7-7.6,5.6C14.7,2.7,11.8,0,8.4,0C3.8,0,0,3.8,0,8.4c0,9.4,9.5,11.9,16,21.2
	c6.1-9.3,16-12.1,16-21.2C32,3.8,28.2,0,23.6,0z"
                              />
                            </svg>
                          )}
                        </span>
                      </div>
                    </div>
                    {!item.attributes.MultipleImage.data && (
                      <div style={{ padding: '15px 50px' }}>
                        <Swiper
                          spaceBetween={20}
                          navigation={true}
                          slidesPerView={6}
                          pagination={{ clickable: true }}
                          modules={[Navigation]}
                          className="nestedSwiper"
                        >
                          <SwiperSlide>
                            <div
                              style={{
                                height: '90px',
                                borderRadius: '5px',
                                overflow: 'hidden'
                              }}
                            >
                              <img
                                src={`${globalIP}${item?.attributes?.CoverImage?.data?.attributes?.url}`}
                                alt=""
                                style={{ width: '100%', height: '100%' }}
                                onClick={() =>
                                  setSelectedImagePath({
                                    url: item?.attributes?.CoverImage?.data?.attributes?.url,
                                    id: item.id,
                                    default: true
                                  })
                                }
                              />
                            </div>
                          </SwiperSlide>
                        </Swiper>
                      </div>
                    )}
                    {item.attributes.MultipleImage.data && (
                      <div style={{ padding: '15px 50px', zIndex: 10000 }}>
                        <Swiper
                          spaceBetween={20}
                          navigation={true}
                          slidesPerView={5}
                          pagination={{ clickable: true }}
                          modules={[Navigation]}
                          className="nestedSwiper"
                          mousewheel
                        >
                          <SwiperSlide>
                            <div
                              style={{
                                height: '80px',
                                borderRadius: '5px',
                                overflow: 'hidden'
                              }}
                              className={
                                selectedImagePath.url ==
                                  item?.attributes?.CoverImage?.data?.attributes?.url &&
                                selectedImagePath.id == item.id
                                  ? 'image-product-select image-product-select-active'
                                  : null
                              }
                            >
                              <img
                                src={`${globalIP}${item?.attributes?.CoverImage?.data?.attributes?.url}`}
                                alt=""
                                style={{ width: '100%', height: '100%' }}
                                onClick={() =>
                                  setSelectedImagePath({
                                    url: item?.attributes?.CoverImage?.data?.attributes?.url,
                                    id: item.id,
                                    default: true
                                  })
                                }
                              />
                            </div>
                          </SwiperSlide>
                          {item.attributes.MultipleImage.data &&
                            item.attributes.MultipleImage.data.map(multiImage => {
                              return (
                                <SwiperSlide key={multiImage.id}>
                                  <div
                                    style={{
                                      height: '80px',
                                      borderRadius: '5px',
                                      overflow: 'hidden'
                                    }}
                                    className={
                                      selectedImagePath.url == multiImage.attributes.url &&
                                      selectedImagePath.id == item.id
                                        ? 'image-product-select image-product-select-active'
                                        : null
                                    }
                                  >
                                    <img
                                      src={`${globalIP}${multiImage.attributes.url}`}
                                      alt=""
                                      style={{ width: '100%', height: '100%' }}
                                      onClick={() =>
                                        setSelectedImagePath({
                                          url: multiImage.attributes.url,
                                          id: item.id,
                                          default: true
                                        })
                                      }
                                    />
                                  </div>
                                </SwiperSlide>
                              );
                            })}
                        </Swiper>
                      </div>
                    )}
                  </Col>
                  <Col lg={12}>
                    <div style={{ padding: '10px 20px' }} className="slide-product-table">
                      {attributesData?.Cust_Productname && (
                        <div className="slide-product-name roboto-medium">
                          {item.attributes.ProductName}
                        </div>
                      )}

                      {attributesData?.Cust_SalePrice && (
                        <div className="slide-product-price ">
                          <div className="roboto-regular">
                            <span className="material-symbols-outlined">currency_rupee</span>
                            {item.attributes.SellingPrice}/-
                          </div>
                        </div>
                      )}
                      {attributesData?.Cust_Description && (
                        <div className="slide-product-details ">
                          <span className="roboto-medium">Description</span>
                          <p className="roboto-regular">{item.attributes.Description}</p>
                        </div>
                      )}
                      <Divider style={{ margin: '10px 0' }} />
                      {attributesData?.Cust_Unit && (
                        <div className="slide-product-dimensions ">
                          <span className="roboto-medium">Dimensions</span>
                          <p className="roboto-regular">
                            {item.attributes.Length}*{item.attributes.Width}*
                            {item.attributes.Height}
                            <span className="product-unit">
                              {capitalizeFirstLetter(item.attributes.SizeUnit)}
                            </span>
                          </p>
                        </div>
                      )}
                      {attributesData?.Cust_Aliascode && (
                        <div className="slide-product-Alias ">
                          <div className="roboto-medium">
                            {attributesName?.AliasCode || 'Alias Code'}
                          </div>
                          <div>{item.attributes.ProductId}</div>
                        </div>
                      )}
                      {attributesData?.Cust_Category && (
                        <div className="slide-product-Alias ">
                          <div className="roboto-medium">
                            {attributesName?.Category || 'Category'}
                          </div>
                          <div>{item.attributes.CategoryName}</div>
                        </div>
                      )}
                      {attributesData?.Cust_Producttype && (
                        <div className="slide-product-Alias ">
                          <div className="roboto-medium">
                            {attributesName?.ProductType || 'Product Type'}
                          </div>
                          <div>{item.attributes.ProductTypeName}</div>
                        </div>
                      )}
                      {attributesData?.Cust_Finish && (
                        <div className="slide-product-Alias ">
                          <div className="roboto-medium">{attributesName?.finish || 'Finish'}</div>
                          <div>{item.attributes.FinishName}</div>
                        </div>
                      )}
                      {attributesData?.Cust_Color && (
                        <div className="slide-product-Alias ">
                          <div className="roboto-medium">{attributesName?.color || 'Color'}</div>
                          <div>{item.attributes.ColorName}</div>
                        </div>
                      )}
                      {attributesData?.Cust_CBM && (
                        <div className="slide-product-Alias ">
                          <div className="roboto-medium">{attributesName?.cbm || 'CBM'}</div>
                          <div>{item.attributes.Total_CBM}</div>
                        </div>
                      )}
                      {attributesData?.Cust_FreeSize && (
                        <div className="slide-product-Alias ">
                          <div className="roboto-medium">
                            {attributesName?.SizeRange || 'Free Size'}
                          </div>
                          <div>{item.attributes.SizeRange}</div>
                        </div>
                      )}
                      {attributesData?.Cust_GrsWgt && (
                        <div className="slide-product-Alias ">
                          <div className="roboto-medium">
                            {attributesName?.GrossWgt || 'Gross Weight'}
                          </div>
                          <div>{item.attributes.GrossWeight}</div>
                        </div>
                      )}
                      {attributesData?.Cust_NetWgt && (
                        <div className="slide-product-Alias ">
                          <div className="roboto-medium">
                            {attributesName?.NetWgt || 'Net Weight'}
                          </div>
                          <div>{item.attributes.NetWeight}</div>
                        </div>
                      )}
                      {!exist ? (
                        <div
                          onClick={() =>
                            handleCheckChange(
                              item.id,
                              !selectedItems.includes(item?.id),
                              item?.attributes.ProductCode
                            )
                          }
                        >
                          {selectedItems.includes(item?.id) ? (
                            <>
                              <div className="bottom-page-slide" style={{ textAlign: 'center' }}>
                                <button
                                  className={
                                    selectedItems.includes(item?.id)
                                      ? 'select-button-1'
                                      : 'select-button'
                                  }
                                >
                                  Selected
                                </button>
                              </div>
                            </>
                          ) : (
                            <div className="bottom-page-slide" style={{ textAlign: 'center' }}>
                              <button
                                className={
                                  selectedItems.includes(item?.id)
                                    ? 'select-button'
                                    : 'select-button'
                                }
                              >
                                Select Product
                              </button>
                            </div>
                          )}
                        </div>
                      ) : (
                        <div>
                          {exist ? (
                            <>
                              <div className="bottom-page-slide" style={{ textAlign: 'center' }}>
                                <button className={'select-button-2'}>Query sent</button>
                              </div>
                            </>
                          ) : (
                            <div className="bottom-page-slide" style={{ textAlign: 'center' }}>
                              <button
                                className={
                                  selectedItems.includes(item?.id)
                                    ? 'select-button'
                                    : 'select-button'
                                }
                              >
                                Select Product
                              </button>
                            </div>
                          )}
                        </div>
                      )}

                      <p className="roboto-regular" style={{ fontSize: '20px' }}>
                        <span className="roboto-regular" style={{ fontSize: '24px' }}>
                          {activeIndex + 1}/
                        </span>
                        <span>{matchingProductIds.length} </span>
                        Products
                      </p>
                    </div>
                  </Col>
                </Row>
              </Grid>
            </SwiperSlide>
          );
        })}
      </Swiper>
      <Swiper
        navigation={false}
        effect={'flip'}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        }}
        modules={[EffectFlip, Autoplay, Navigation]}
        onSlideChange={item => setActiveIndex(item.activeIndex)}
        className="mySwiper mobile-show-slide"
        style={{ zIndex: 100, marginBottom: '80px' }}
      >
        {fetchedProducts.map((item, index) => {
          const exist = allQyeryData?.some(it => it?.productid == item?.id);
          return (
            <SwiperSlide key={item.id}>
              <Grid fluid>
                <Row>
                  <Col lg={12} xs={24}>
                    <div className="slide-main-image">
                      <img
                        src={
                          selectedImagePath.url && selectedImagePath.id == item.id
                            ? `${globalIP}${selectedImagePath.url}`
                            : `${globalIP}${item?.attributes?.CoverImage?.data?.attributes?.url}`
                        }
                        alt=""
                        className="iiimge"
                      />
                      <div className="selected-button" style={{ zIndex: 100 }}>
                        <span className="heart-circle">
                          {!exist ? (
                            <div
                              onClick={() =>
                                handleCheckChange(
                                  item.id,
                                  !selectedItems.includes(item.id),
                                  item.attributes.ProductCode
                                )
                              }
                              style={{ display: 'flex' }}
                            >
                              {selectedItems.includes(item.id) ? (
                                <svg className="heart" viewBox="0 0 32 29.6">
                                  <path
                                    d="M23.6,0c-3.4,0-6.3,2.7-7.6,5.6C14.7,2.7,11.8,0,8.4,0C3.8,0,0,3.8,0,8.4c0,9.4,9.5,11.9,16,21.2
	c6.1-9.3,16-12.1,16-21.2C32,3.8,28.2,0,23.6,0z"
                                  />
                                </svg>
                              ) : (
                                <span className="material-symbols-outlined">favorite</span>
                              )}
                            </div>
                          ) : (
                            <svg className="heart-1" viewBox="0 0 32 29.6">
                              <path
                                d="M23.6,0c-3.4,0-6.3,2.7-7.6,5.6C14.7,2.7,11.8,0,8.4,0C3.8,0,0,3.8,0,8.4c0,9.4,9.5,11.9,16,21.2
	c6.1-9.3,16-12.1,16-21.2C32,3.8,28.2,0,23.6,0z"
                              />
                            </svg>
                          )}
                        </span>
                      </div>
                    </div>
                    {!item.attributes.MultipleImage.data && (
                      <div style={{ padding: '15px 50px' }}>
                        <Swiper
                          spaceBetween={20}
                          navigation={true}
                          slidesPerView={3}
                          pagination={{ clickable: true }}
                          modules={[Navigation]}
                          className="nestedSwiper"
                        >
                          <SwiperSlide>
                            <div
                              style={{
                                height: '80px',
                                borderRadius: '5px',
                                overflow: 'hidden'
                              }}
                            >
                              <img
                                src={`${globalIP}${item?.attributes?.CoverImage?.data?.attributes?.url}`}
                                alt=""
                                style={{ width: '100%', height: '100%' }}
                                onClick={() =>
                                  setSelectedImagePath({
                                    url: item?.attributes?.CoverImage?.data?.attributes?.url,
                                    id: item.id,
                                    default: true
                                  })
                                }
                              />
                            </div>
                          </SwiperSlide>
                        </Swiper>
                      </div>
                    )}
                    {item.attributes.MultipleImage.data && (
                      <div style={{ padding: '15px 20px', zIndex: 10000 }}>
                        <Swiper
                          spaceBetween={20}
                          navigation={true}
                          slidesPerView={3}
                          pagination={{ clickable: true }}
                          modules={[Navigation]}
                          className="nestedSwiper"
                          mousewheel
                        >
                          <SwiperSlide>
                            <div
                              style={{
                                height: '80px',
                                borderRadius: '5px',
                                overflow: 'hidden'
                              }}
                              className={
                                selectedImagePath.url ==
                                  item?.attributes?.CoverImage?.data?.attributes?.url &&
                                selectedImagePath.id == item.id
                                  ? 'image-product-select image-product-select-active'
                                  : null
                              }
                            >
                              <img
                                src={`${globalIP}${item?.attributes?.CoverImage?.data?.attributes?.url}`}
                                alt=""
                                style={{ width: '100%', height: '100%' }}
                                onClick={() =>
                                  setSelectedImagePath({
                                    url: item?.attributes?.CoverImage?.data?.attributes?.url,
                                    id: item.id,
                                    default: true
                                  })
                                }
                              />
                            </div>
                          </SwiperSlide>
                          {item.attributes.MultipleImage.data &&
                            item.attributes.MultipleImage.data.map(multiImage => {
                              return (
                                <SwiperSlide key={multiImage.id}>
                                  <div
                                    style={{
                                      height: '80px',
                                      borderRadius: '5px',
                                      overflow: 'hidden'
                                    }}
                                    className={
                                      selectedImagePath.url == multiImage.attributes.url &&
                                      selectedImagePath.id == item.id
                                        ? 'image-product-select image-product-select-active'
                                        : null
                                    }
                                  >
                                    <img
                                      src={`${globalIP}${multiImage.attributes.url}`}
                                      alt=""
                                      style={{ width: '100%', height: '100%' }}
                                      onClick={() =>
                                        setSelectedImagePath({
                                          url: multiImage.attributes.url,
                                          id: item.id,
                                          default: true
                                        })
                                      }
                                    />
                                  </div>
                                </SwiperSlide>
                              );
                            })}
                        </Swiper>
                      </div>
                    )}
                  </Col>
                  <Col lg={12} xs={24}>
                    <div style={{ padding: '10px 20px' }} className="slide-product-tabl">
                      {attributesData?.Cust_Productname && (
                        <div className="slide-product-name roboto-medium">
                          {item.attributes.ProductName}
                        </div>
                      )}

                      {attributesData?.Cust_SalePrice && (
                        <div className="slide-product-price ">
                          <div className="roboto-regular">
                            <span className="material-symbols-outlined">currency_rupee</span>
                            {item.attributes.SellingPrice}/-
                          </div>
                        </div>
                      )}
                      {attributesData?.Cust_Description && (
                        <div className="slide-product-details ">
                          <span className="roboto-medium">Description</span>
                          <p className="roboto-regular">{item.attributes.Description}</p>
                        </div>
                      )}
                      <Divider style={{ margin: '10px 0' }} />
                      {attributesData?.Cust_Unit && (
                        <div className="slide-product-dimensions ">
                          <span className="roboto-medium">Dimensions</span>
                          <p className="roboto-regular">
                            {item.attributes.Length}*{item.attributes.Width}*
                            {item.attributes.Height}
                            <span className="product-unit">
                              {capitalizeFirstLetter(item.attributes.SizeUnit)}
                            </span>
                          </p>
                        </div>
                      )}
                      {attributesData?.Cust_Aliascode && (
                        <div className="slide-product-Alias ">
                          <div className="roboto-medium">
                            {attributesName?.AliasCode || 'Alias Code'}
                          </div>
                          <div>{item.attributes.ProductId}</div>
                        </div>
                      )}
                      {attributesData?.Cust_Category && (
                        <div className="slide-product-Alias ">
                          <div className="roboto-medium">
                            {attributesName?.Category || 'Category'}
                          </div>
                          <div>{item.attributes.CategoryName}</div>
                        </div>
                      )}
                      {attributesData?.Cust_Producttype && (
                        <div className="slide-product-Alias ">
                          <div className="roboto-medium">
                            {attributesName?.ProductType || 'Product Type'}
                          </div>
                          <div>{item.attributes.ProductTypeName}</div>
                        </div>
                      )}
                      {attributesData?.Cust_Finish && (
                        <div className="slide-product-Alias ">
                          <div className="roboto-medium">{attributesName?.finish || 'Finish'}</div>
                          <div>{item.attributes.FinishName}</div>
                        </div>
                      )}
                      {attributesData?.Cust_Color && (
                        <div className="slide-product-Alias ">
                          <div className="roboto-medium">{attributesName?.color || 'Color'}</div>
                          <div>{item.attributes.ColorName}</div>
                        </div>
                      )}
                      {attributesData?.Cust_CBM && (
                        <div className="slide-product-Alias ">
                          <div className="roboto-medium">{attributesName?.cbm || 'CBM'}</div>
                          <div>{item.attributes.Total_CBM}</div>
                        </div>
                      )}
                      {attributesData?.Cust_FreeSize && (
                        <div className="slide-product-Alias ">
                          <div className="roboto-medium">
                            {attributesName?.SizeRange || 'Free Size'}
                          </div>
                          <div>{item.attributes.SizeRange}</div>
                        </div>
                      )}
                      {attributesData?.Cust_GrsWgt && (
                        <div className="slide-product-Alias ">
                          <div className="roboto-medium">
                            {attributesName?.GrossWgt || 'Gross Weight'}
                          </div>
                          <div>{item.attributes.GrossWeight}</div>
                        </div>
                      )}
                      {attributesData?.Cust_NetWgt && (
                        <div className="slide-product-Alias ">
                          <div className="roboto-medium">
                            {attributesName?.NetWgt || 'Net Weight'}
                          </div>
                          <div>{item.attributes.NetWeight}</div>
                        </div>
                      )}
                      {!exist ? (
                        <div
                          onClick={() =>
                            handleCheckChange(
                              item.id,
                              !selectedItems.includes(item?.id),
                              item?.attributes.ProductCode
                            )
                          }
                        >
                          {selectedItems.includes(item?.id) ? (
                            <>
                              <div className="bottom-page-slide" style={{ textAlign: 'center' }}>
                                <button
                                  className={
                                    selectedItems.includes(item?.id)
                                      ? 'select-button-1'
                                      : 'select-button'
                                  }
                                >
                                  Selected
                                </button>
                              </div>
                            </>
                          ) : (
                            <div className="bottom-page-slide" style={{ textAlign: 'center' }}>
                              <button
                                className={
                                  selectedItems.includes(item?.id)
                                    ? 'select-button'
                                    : 'select-button'
                                }
                              >
                                Select Product
                              </button>
                            </div>
                          )}
                        </div>
                      ) : (
                        <div>
                          {exist ? (
                            <>
                              <div className="bottom-page-slide" style={{ textAlign: 'center' }}>
                                <button className={'select-button-2'}>Query sent</button>
                              </div>
                            </>
                          ) : (
                            <div className="bottom-page-slide" style={{ textAlign: 'center' }}>
                              <button
                                className={
                                  selectedItems.includes(item?.id)
                                    ? 'select-button'
                                    : 'select-button'
                                }
                              >
                                Select Product
                              </button>
                            </div>
                          )}
                        </div>
                      )}

                      <p className="roboto-regular" style={{ fontSize: '20px' }}>
                        <span className="roboto-regular" style={{ fontSize: '24px' }}>
                          {activeIndex + 1}/
                        </span>
                        <span>{matchingProductIds.length} </span>
                        Products
                      </p>
                    </div>
                  </Col>
                </Row>
              </Grid>
            </SwiperSlide>
          );
        })}
      </Swiper>
      {selectedItems.length > 0 && (
        <Notification
          type="success"
          className="bottom-Open"
          style={{
            position: 'fixed',
            top: '19%',
            right: 20,
            transform: 'translateY(-50%)',
            zIndex: 9999,
            background: '#005c80',
            color: 'white',
            width: 'auto'
          }}
        >
          <b style={{ color: 'white' }}>My Selected Products : {selectedItems.length}</b>
          <Divider vertical />
          <Button
            style={{ float: 'right', marginTop: '-7px' }}
            onClick={() =>
              navigate(`/${ugr}/client/buyers`, {
                state: {
                  selectedItems: selectedItems.join(','),
                  cltco: cltCode,
                  C_A_id: C_A_id
                }
              })
            }
            appearance="subtle"
            active
          >
            <b>Sent Query</b>
          </Button>
        </Notification>
      )}
      {isSelectedLoading && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            height: '100vh',
            position: 'absolute',
            top: 0,
            left: 0
          }}
          className="loading-bg"
        >
          <Loader size="lg" />
        </div>
      )}
      <Stack
        className="copyright"
        justifyContent="flex-end"
        spacing={5}
        style={{
          position: 'fixed',
          bottom: '0',
          width: '-webkit-fill-available',
          textAlign: 'center',
          backgroundColor: 'white',
          padding: '10px 20px',
          borderTop: '1px solid lightGrey',
          zIndex: 100000000000000000000,
          background: 'white'
        }}
      >
        <p>© All Right Reserved. Product by </p>
        <p>
          <a href="https://erpdaddy.com/" target="_blank" color="#005c80">
            ERPDaddy Software Solution.
          </a>
        </p>
      </Stack>
    </div>
  );
}
